module.exports = __webpack_public_path__ + "static/img/picture13.896a5a97.png";